module.exports = __webpack_public_path__ + "assets/img/img_2022.2dd822a1.jpg";